import { memo } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// -----------------------------------------------------------------------------

const BoxSX = {
  display: "flex",
  alignItems: "center",
  p: 2,

  "&:nth-of-type(even)": { background: "rgba(0, 0, 0, 0.05)" },

  "&:last-child": { borderRadius: "0 0 12px 12px" },

  "@media screen and (max-width:800px)": {
    alignItems: "flex-start",
  },
};

const TypographySX = {
  display: "block",
  maxWidth: "128px",
  flexBasis: "20%",
  flexShrink: 0,
  flexGrow: 0,
  mr: 1,
};

// -----------------------------------------------------------------------------

const OrganizationFindingAbstractRow = memo(
  function OrganizationFindingAbstractRow({
    label,
    children,
  }: OrganizationFindingAbstractRowProps): JSX.Element | null {
    return (
      <Box sx={BoxSX}>
        <Typography variant="body1" fontWeight="bold" sx={TypographySX}>
          {label}
        </Typography>
        {children}
      </Box>
    );
  }
);

export default OrganizationFindingAbstractRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingAbstractRowProps {
  label: string;
  children: React.ReactNode;
}
